package de.katoonerie.content

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import de.katoonerie.components.Container
import de.katoonerie.components.Gradient
import de.katoonerie.components.Prose
import kotlinx.browser.window
import org.jetbrains.compose.web.dom.B
import org.jetbrains.compose.web.dom.Br
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.H3
import org.jetbrains.compose.web.dom.Hr
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text
import org.jetbrains.compose.web.dom.Ul

@Composable
fun AppPrivacy() {
    LaunchedEffect("privacy-app") {
        window.scrollTo(0.0, 0.0)
    }
    Gradient {
        Container(attrs = { classes("py-8") }) {
            Prose(attrs = { classes("p-4") }) {
                H1 {
                    Text("Datenschutzerklärung")
                    Br()
                    Span(attrs = { classes("text-xl") }) {
                        Text("(für die App \"Jesus Verstehen\")")
                    }
                }
                H2 { Text("Datenschutzerklärung für Kinder") }
                Hr()
                H3 { Text("Hallo!") }
                P { Text("Wir freuen uns, dass du unsere App benutzt. Es ist uns sehr wichtig, deine Daten zu schützen. Hier erklären wir dir, wie wir mit deinen Informationen umgehen.") }
                H3 { Text("Wer wir sind") }
                P {
                    Text("Wir sind Elisabeth Hotze und Vera Kappert-Hölter von der Katechetischen Cartoonerie. Du kannst uns erreichen unter:")
                    ContactForChildren()
                }
                H3 { Text("Welche Daten sammeln wir?") }
                P { Text("Wir sammeln keine Daten von dir. Das bedeutet, dass wir nichts über dich wissen, wenn du unsere App benutzt. Wir fragen dich auch nicht nach deinem Namen, deiner Adresse oder anderen persönlichen Informationen.") }
                H3 { Text("Warum sammeln wir keine Daten?") }
                P { Text("Wir wollen, dass du unsere App sicher benutzen kannst. Deshalb haben wir sie so gemacht, dass wir keine Daten von dir brauchen.") }
                H3 { Text("Was passiert, wenn sich etwas ändert?") }
                P { Text("Manchmal müssen wir unsere Datenschutzerklärung ändern, damit alles richtig bleibt. Wenn das passiert, bekommst du eine Nachricht in der App, damit du Bescheid weißt.") }
                H3 { Text("Deine Rechte") }
                P { Text("Weil wir keine Daten von dir sammeln, gibt es auch keine Daten, die wir löschen oder ändern könnten. Wenn du Fragen hast, kannst du uns aber immer schreiben oder anrufen.") }
                H3 { Text("Wie du uns erreichen kannst") }
                P {
                    Text("Wenn du oder deine Eltern Fragen habt, könnt ihr uns so erreichen:")
                    ContactForChildren()
                }
                H3 { Text("Vielen Dank!") }
                P { Text("Wir freuen uns, dass du unsere App benutzt und hoffen, dass sie dir Spaß macht!") }
                P { Text("Diese Erklärung gilt ab dem 1. Juni 2024.") }

                H2 { Text("Datenschutzerklärung") }
                Hr()
                H3 { Text("Einleitung") }
                P { Text("Wir freuen uns, dass Sie unsere mobile Applikation (im Folgenden \"App\" genannt) nutzen. Der Schutz Ihrer persönlichen Daten ist uns ein wichtiges Anliegen. Diese Datenschutzerklärung informiert Sie darüber, wie wir mit Ihren personenbezogenen Daten umgehen, wenn Sie unsere App nutzen. Unsere App verarbeitet keine personenbezogenen Daten von Benutzern.") }
                H3 { Text("Verantwortlicher") }
                P {
                    Text("Verantwortlicher im Sinne der Datenschutz-Grundverordnung (DSGVO) ist:")
                    Br()
                    Br()
                    ContactForAdults()
                }
                H3 { Text("Allgemeine Informationen zur Datenverarbeitung") }
                P { Text("Unsere App ist so konzipiert, dass keine personenbezogenen Daten verarbeitet oder gespeichert werden. Wir erheben keine Daten über Ihre Identität, Ihren Standort oder andere personenbezogene Informationen.") }
                H3 { Text("Automatisierte Entscheidungsfindung und Profiling") }
                P { Text("Wir nutzen keine automatisierten Entscheidungsprozesse oder Profiling-Methoden.") }
                H3 { Text("Änderungen dieser Datenschutzerklärung") }
                P { Text("Wir behalten uns vor, diese Datenschutzerklärung gelegentlich anzupassen, um sicherzustellen, dass sie stets den aktuellen rechtlichen Anforderungen entspricht oder um Änderungen unserer App in der Datenschutzerklärung umzusetzen. Für Ihren erneuten Besuch gilt dann die neue Datenschutzerklärung.") }
                H3 { Text("Ihre Rechte") }
                P { Text("Da wir keine personenbezogenen Daten verarbeiten, können Sie Ihre Rechte gemäß der DSGVO, wie das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung der Verarbeitung, Datenübertragbarkeit und Widerspruch, in Bezug auf diese Datenschutzerklärung zwar geltend machen, jedoch ohne praktische Relevanz. Sollten Sie dennoch Fragen haben, können Sie sich jederzeit an uns wenden.") }
                H3 { Text("Kontakt") }
                P {
                    ContactForAdults()
                }
                H3 { Text("Schlussbemerkung") }
                P { Text("Wir danken Ihnen für Ihr Vertrauen und hoffen, dass Sie unsere App mit Freude nutzen.") }
                P { Text("Diese Datenschutzerklärung ist gültig ab dem 1. Juni 2024") }
            }
        }
    }
}

@Composable
fun ContactForChildren() {
    Ul {
        Li {
            B { Text("Adresse: ") }
            Text("Dr. Elisabeth Hotze, Katechetische Cartoonerie, Im Schee 25, 45276 Essen")
        }
        Li {
            B { Text("E-Mail: ") }
            Text("katoonerie@gmail.com")
        }
        Li {
            B { Text("Telefon: ") }
            Text("0201 / 510154")
        }
    }
}

@Composable
fun ContactForAdults() {
    Text("Dr. Elisabeth Hotze")
    Br()
    Text("Katechetische Cartoonerie")
    Br()
    Text("Im Schee 25")
    Br()
    Text("45276 Essen")
    Br()
    Text("E-Mail: katoonerie@gmail.com")
    Br()
    Text("Telefon: 0201 / 510154")
}
